import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function LoginForm({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // Passwort-Reset-Funktion entfernt

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin({ email, password });
  };

  // handleResetSubmit function removed (no longer needed)

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
      <div className="space-y-2">
        <Label htmlFor="login-email">E-Mail</Label>
        <Input
          id="login-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          data-testid="login-email-input"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="login-password">Passwort</Label>
        <Input
          id="login-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          data-testid="login-password-input"
        />
      </div>
      <Button
        type="submit"
        className="w-full rounded-full bg-sky-600 text-white hover:bg-sky-500"
        data-testid="login-submit-button"
      >
        Anmelden
      </Button>

      {/* Passwort-vergessen-Funktion entfernt (nicht benötigt) */}
    </form>
  );
}